import { LinkChildren } from './LinkChildren'
import type { TagResult } from '../data/TagFragment'
import styles from './Tags.module.sass'

export type TagsProps = {
	tags?: Array<TagResult & { color?: string }>
}
export const Tags = ({ tags }: TagsProps) => {
	if (!tags || tags.length === 0) return null

	return (
		<div className={styles.tagsWrapper}>
			{tags.map((tag) => {
				const bg = tag.color ?? '#000'
				const linkUrl = tag?.linkable?.url

				if (linkUrl) {
					return (
						<LinkChildren
							key={`${tag.name}-${tag?.link?.id || Math.random()}`}
							type="internal"
							link={{ url: linkUrl }}
							className={styles.tag}
							style={{ backgroundColor: bg }}
						>
							<span>{tag.name}</span>
						</LinkChildren>
					)
				}

				return (
					<span
						key={`${tag.name}-${tag?.link?.id || Math.random()}`}
						className={styles.tag}
						style={{ backgroundColor: bg }}
					>
						{tag.name}
					</span>
				)
			})}
		</div>
	)
}

// export type TagTitleProps = {
// 	title: string
// 	link?: LinkResult | null
// 	color?: string
// 	size?: 'small' | 'medium' | 'large'
// }

// export const TagTitle: FunctionComponent<TagTitleProps> = ({ title, link, color = '#333', size = 'medium' }) => {
// 	const className = `${styles.tagTitle} ${styles[size]}`

// 	if (link?.internalLink?.url) {
// 		return (
// 			<LinkChildren
// 				type="internal"
// 				link={{ url: link.internalLink.url }}
// 				className={className}
// 				style={{ backgroundColor: color }}
// 			>
// 				{title}
// 			</LinkChildren>
// 		)
// 	}

// 	if (link?.externalLink) {
// 		return (
// 			<LinkChildren
// 				type="default"
// 				link={{
// 					id: '',
// 					isTargetBlank: false,
// 					type: 'external',
// 					externalLink: link.externalLink,
// 				}}
// 				className={className}
// 				style={{ backgroundColor: color }}
// 			>
// 				{title}
// 			</LinkChildren>
// 		)
// 	}

// 	return (
// 		<span className={className} style={{ backgroundColor: color }}>
// 			{title}
// 		</span>
// 	)
// }
